/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';

import NavBar from '../../components/NavBar';
import Load from '../../components/Load';

import { getToken } from '../../api/auth';
import calendarUSAMask from '../../utils/masks/calendarUSAMask';

import { ClaimsFetch } from '../../api/services/NotebookAPI';

export default function Claim({ history }) {
  const token = getToken();
  const [claims, setClaims] = useState([]);
  const [messageWarning, setMessageWarning] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function getClaims() {
      setIsLoad(true);
      try {
        const resultClaims = await ClaimsFetch(token);
        console.log('getClaims | resultClaims: ', resultClaims);
        setIsLoad(false);
        setMessageWarning(resultClaims.message);
        setIsSuccessMessage(resultClaims.isSuccess);
        if (resultClaims.isSuccess) {
          setClaims(resultClaims.claims);
        }
      } catch (error) {
        console.log('getClaims | error: ', error);
        setIsSuccessMessage(false);
        setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
        setIsLoad(false);
      }
    }

    getClaims();
  }, [history, token]);

  return (
    <>
      <Load isShow={isLoad} />
      <NavBar navigation={history} />
      <div className="container__above_header">
        <div className="form">
          <p className="form__description">
            Histórico de Reclamações
          </p>

          {messageWarning && <p className={isSuccessMessage ? 'form__message form__message--success' : 'form__message form__message--error'}>{messageWarning}</p>}

          <button
            className="form__button"
            type="button"
            // eslint-disable-next-line no-undef
            onClick={() => navigate('/notebook/claim/create', { replace: true })}
          >
            Registrar Reclamação
          </button>

          {claims.map((claim) => (
            <div
              className="detail__container"
              onClick={() => navigate(`/notebook/claim/${claim.id}`, { replace: true })}
              aria-hidden="true"
            >
              <p className="detail__value">
                {(claim.subject).toUpperCase()}
              </p>
              <p className="detail__value">
                {calendarUSAMask(claim.created)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
